/**
 * Calculates the start date corresponding to a given time range.
 *
 * @param {Date} lastSessionDate - The most recent available date in the dataset.
 * @param {Date} firstSessionDate - The earliest available date in the dataset.
 * @param {string} range - One of: "5D", "1M", "6M", "YTD", "1Y", "5Y", "MAX".
 * @returns {string} A human-readable date string (via `toDateString()`).
 *
 * @description
 * Computes the date limit corresponding to the selected range relative to the last session date.  
 * Returns a new `Date` object converted to a readable string.  
 *
 * Logic note:
 * - Dates are cloned at the start to prevent mutation of the original objects.
 * - The "MAX" option returns the first session date (the oldest record).
 * - Default case reverts to a 5-day window.
 */
export const getDateCorrespondingToRange = (lastSessionDate, firstSessionDate, range) => {

    // Date copy creation to avoid original object mutation
    const last = new Date(lastSessionDate);

    switch (range) {
        case ('5D'):
            return (new Date(last.setDate(last.getDate() - 5))).toDateString()
        case ('1M'):
            return (new Date(last.setMonth(last.getMonth() - 1))).toDateString()
        case ('6M'):
            return (new Date(last.setMonth(last.getMonth() - 6))).toDateString()
        case ('YTD'):
            return (new Date(last.getFullYear(), 0, 1)).toDateString()
        case ('1Y'):
            return (new Date(last.setFullYear(last.getFullYear() - 1))).toDateString()
        case ('5Y'):
            return (new Date(last.setFullYear(last.getFullYear() - 5))).toDateString()
        case ('MAX'):
            return firstSessionDate.toDateString()
        default:
            return (new Date(last.setDate(last.getDate() - 5))).toDateString()
    }
}